import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import FurtherInformations from "./FurtherInformations";
import { getValue } from "../../../../_helpers/stringHelper";
import { DataDwellingInfos } from "../../interfaces";
import { UPDATE_DWELLING } from "../../routes";
import { getLastTenant, getLastTenantEmail } from "../DwellingSheetDetails";

const DwellingFurtherInformation = ({ data }: { data: DataDwellingInfos }) => {
  const renderValue = (value: string) => {
    if (value === "Inconnu(e)" || value === "" || value === null) {
      return (
        <Link
          className="link"
          to={UPDATE_DWELLING.replace(
            ":id",
            data.datedReference || data.id || "",
          ).replace(":isAssociatingBuilding", "false")}
        >
          Ajouter l'information
        </Link>
      );
    } else {
      return value;
    }
  };

  return (
    <div className="bg-container">
      <div className="propertySheetDetailsPartTitle mb-3">
        {" "}
        Informations complémentaires
      </div>
      <Row>
        <Col xs={6} lg={3}>
          <FurtherInformations
            title="Syndicat de copropriété"
            value={renderValue(getValue(data.condominiumSyndicate))}
          />
        </Col>
        <Col xs={6} lg={3}>
          <FurtherInformations
            title="Propriétaire"
            value={renderValue(getValue(data.lessor))}
          />
        </Col>
        <Col xs={6} lg={3} className="pt-4 pt-lg-0">
          <FurtherInformations
            title="Occupant"
            value={getLastTenant(data.currentTenants)}
            contact={getLastTenantEmail(data.currentTenants)}
          />
        </Col>
        <Col xs={6} lg={3} className="pt-4 pt-lg-0">
          <FurtherInformations
            title="N° fiscal du local"
            value={renderValue(getValue(data.taxNumber))}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DwellingFurtherInformation;
